export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15003.f31170f4.jpg";